import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NAVBAR_THEME } from 'lib/navbar';
import BTE from 'lib/BTE';
import { setTheme as setThemeAction } from 'redux/modules/navbar';


const mapActionsToProps = (dispatch) => ({
  setTheme: (theme) => dispatch(setThemeAction(theme)),
});

const mapStateToProps = ({
  layout,
  navbar,
}) => ({
  triggerTop: layout.triggerTop,
  navTheme: navbar.theme,
});

@connect(mapStateToProps, mapActionsToProps)
class Wrapper extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    setTheme: PropTypes.func.isRequired,
    navTheme: PropTypes.string.isRequired,
    packageIndex: PropTypes.number,
    triggerTop: PropTypes.number.isRequired,
  }

  static contextTypes = {
    layoutIndex: PropTypes.number,
  }

  static defaultProps = {
    packageIndex: 0,
  }

  componentDidMount() {
    const { layoutIndex } = this.context;
    const { packageIndex } = this.props;
    if (layoutIndex === 0 && packageIndex === 0) {
      BTE.on('scroll', this.handleScroll, 'throttle');
    }
  }

  componentWillUnmount() {
    const { layoutIndex } = this.context;
    const { packageIndex } = this.props;
    if (layoutIndex === 0 && packageIndex === 0) {
      BTE.remove('scroll', this.handleScroll);
    }
  }

  handleScroll = (depth) => {
    const { navTheme, setTheme, triggerTop } = this.props;

    if (depth > triggerTop && navTheme !== NAVBAR_THEME.LIGHT) {
      setTheme(NAVBAR_THEME.LIGHT);
      return;
    }

    if (depth <= triggerTop && navTheme !== NAVBAR_THEME.TRANSPARENT) {
      setTheme(NAVBAR_THEME.TRANSPARENT);
    }
  }

  render() {
    const {
      id,
      className,
      children,
    } = this.props;

    return (
      <div
        data-packageid={id}
        className={className}
        ref={(e) => { this.container = e; }}
      >
        {children}
      </div>
    );
  }
}

export default Wrapper;
